<template>
  <div>
    <h1>Visualizar pedido</h1>
    <Form />
  </div>
</template>

<script>
import Form from "../Components/Form.vue";

export default {
  components: { Form },
};
</script>

<style></style>
